import { ROLE } from '@app/constants/permission'

export const DEFAULT_VALUES_COMMENT_FORM = {
  sampleIds: [],
  message: ''
}

export const SAVE_ITEM_ROLES = [ROLE.administrator, ROLE.pricingSpecialist, ROLE.priceAnalyticsSpecialist]

export const SAVE_COMMENT_ROLES = [
  ROLE.administrator,
  ROLE.commercialServiceDirector,
  ROLE.commercialServiceSpecialist,
  ROLE.promoPlanningSpecialist,
  ROLE.categoryManager
]
